import { FC, type JSX } from 'react';

import { Switch as MuiSwitch } from '@mui/material';

import './Switch.sass';

type Props = {
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: () => void;
  id?: string;
  ariaLabel?: string;
};

const Switch: FC<Props> = ({
  isChecked,
  isDisabled = false,
  onChange,
  id,
  ariaLabel,
}: Props): JSX.Element => {
  return (
    <div className="switch">
      <MuiSwitch
        color="default"
        checked={isChecked}
        onChange={onChange}
        inputProps={{
          id: `${id}`,
          ...(ariaLabel ? { 'aria-label': ariaLabel } : {}),
        }}
        disabled={isDisabled}
      />
    </div>
  );
};

export default Switch;
